__webpack_require__.p = "/.resources/alive-landingpage/webresources/dist/";